"use client"
import { extendTheme, theme } from "@chakra-ui/react"
import { fonts } from "../assets/fonts"
import { avatarTheme } from "./customComponents/avatarTheme"
import buttonTheme from "./customComponents/buttonTheme"
import iconButtonTheme from "./customComponents/iconButtonTheme"
import {
  BRAND_PRIMARY_COLOR,
  getContrastingTextColor,
} from "./workspaceBranding"

export const desktopThreshold = "768px"

const colors = {
  primaryColor: BRAND_PRIMARY_COLOR,
  primaryColorText: "#000000",
  secondary: {
    light: "#EAEAEA",
    medium: "#D9D9D9",
    dark: "#969696",
  },
  surface: "#F3F4F4",
  gray: {
    50: "#D9D9D94D",
    100: "#A9A9A9",
  },
}

const sizes = {
  ...theme.space,
  container: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1400px",
  },
}

export function buildBrandingTheme(primaryColor?: string | null) {
  const resolvedPrimaryColor = primaryColor || colors.primaryColor
  return extendTheme({
    sizes,
    colors: {
      ...colors,
      primaryColor: resolvedPrimaryColor,
      primaryColorText: getContrastingTextColor(resolvedPrimaryColor),
    },
    initialColorMode: "light",
    useSystemColorMode: false,
    components: {
      Button: buttonTheme,
      IconButton: iconButtonTheme,
      Avatar: avatarTheme,
    },
    fonts,
  })
}

const customTheme = buildBrandingTheme()

export default customTheme
